import { fetchContractStatuses } from './fetchStatuses'

export const contractStatuses = {
  index() {
    return fetchContractStatuses()
  },
}
